(() => {
  if (customElements.get('doop-processing-notice')) return;
  customElements.define('doop-processing-notice', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = 'doop-processing-notice:' + this.dialog.textContent.trim();
      this.close = () => this.dialog.close();
      this.onClosed = () => {
        if (this.dataset.once === 'true') {
          try { sessionStorage.setItem(this.key, '1'); } catch (error) {}
        }
        document.documentElement.style.overflow = this.previousOverflow || '';
        if (this.previousFocus?.isConnected) this.previousFocus.focus();
      };
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', this.close));
      this.dialog.addEventListener('close', this.onClosed);
      if (this.dataset.preview !== 'true' && this.dataset.once === 'true') {
        try { if (sessionStorage.getItem(this.key)) return; } catch (error) {}
      }
      this.openWhenReady();
    }
    openWhenReady() {
      if (!this.isConnected || this.dialog.open) return;
      const otherModal = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])');
      if (otherModal && otherModal !== this.dialog && otherModal.getClientRects().length) {
        this.timer = setTimeout(() => this.openWhenReady(), 500);
        return;
      }
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.querySelector('[data-close]').focus();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) { this.dialog.close(); this.onClosed(); }
      this.dialog?.removeEventListener('close', this.onClosed);
      this.querySelectorAll('[data-close]').forEach(button => button.removeEventListener('click', this.close));
    }
  });
})();
